export default "__VITE_ASSET__C1l5obF5__";